import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch } from 'react-redux';
import styles from './Editor.module.scss';
import { PiSelectionBackgroundThin } from 'react-icons/pi';
import PropTypes from 'prop-types'

export default function Editor ({ template, setEditorContent, extraClass, setSelectContent, preview, setBackgroundsModal, backgroundsModal }) {
    const dispatch = useDispatch();

    const [content, setContent] = useState(
        `<h1>${template.heading || 'Heading'}</h1><h2>${template.subheading || 'Subheading'}</h2>`
    );

    useEffect(() => {
        extractHeadingSubheading(content);
    }, [content]);

    const handleChange = (newContent) => {
        if (preview) return;

        setContent(newContent);
        dispatch({
            type: 'UPDATE_TEMPLATE',
            payload: { id: template.id, content: newContent }
        });
        extractHeadingSubheading(newContent);
    };

    const extractHeadingSubheading = (htmlContent) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;

        const headingElem = tempDiv.querySelector('h1');
        const subheadingElem = tempDiv.querySelector('h2');

        const heading = headingElem ? headingElem.outerHTML : '';
        const subheading = subheadingElem ? subheadingElem.outerHTML : '';

        setEditorContent({ heading, subheading });
    };

    return (
        <div className={`${styles.editorContainer} ${styles[extraClass]}`}>

            {!preview && (
                <div className={styles.right}>
                    <div
                        onClick={() => setBackgroundsModal(!backgroundsModal)}
                        className={styles.backgroundsIcons}>
                        <PiSelectionBackgroundThin />
                    </div>
                    <button className={styles.selectContentBtn} onClick={() => setSelectContent(true)}>
                        Select Content
                    </button>
                </div>
            )}
            {preview 
            ? (
                <div className={styles.previewContent} dangerouslySetInnerHTML={{ __html: content }} />
            ) 
            : (
                <ReactQuill
                    className='custom-editor'
                    value={content}
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                />
            )}
        </div>
    );
}

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block'],
        ['clean']
    ]
};

// Allowed Formats
const formats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'align',
    'list', 'bullet',
    'blockquote', 'code-block'
];

Editor.propTypes = {
    template: PropTypes.object,
    setEditorContent: PropTypes.func,
    extraClass: PropTypes.string,
    setSelectContent: PropTypes.func,
    preview: PropTypes.bool,
    setBackgroundsModal: PropTypes.func,
    backgroundsModal: PropTypes.bool
}
